// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3YnIf","icon":"SortAdornment_icon__3qqn5","up":"SortAdornment_up__2lnw8","down":"SortAdornment_down__k4fG6","active":"SortAdornment_active__12KGy"};